"use strict";

var _TagManager = _interopRequireDefault(require("./TagManager"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
module.exports = _TagManager.default;